var style = {
    backgroundColor: "#F8F8F8",
    borderTop: "1px solid #E7E7E7",
    padding: "0px",
    position: "fixed",
    left: "0",
    bottom: "0",
    height: "40px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}

var phantom = {
    display: 'block',
    padding: '0px',
    height: '50px',
    width: '100%',
}

function Footer({ children }) {
    return (
        <div>
            <div style={phantom} />
            <div style={style}>

                <div style={{ fontSize: 12, color: '#c0c0c0' }}>Copyright © 2019 MERX US LLC. </div>
            </div>
        </div>
    )
}

export default Footer